/* eslint-disable camelcase */
import { getTeamLabelByNumber } from '../../utils/utils'
import { cloneDeep } from '@/utils/utils'

function setGamerCondition (event) {
  const { extra, EventCode } = event
  const { getIngameData, currentSportEvents } = this
  const { gamerCondition } = getIngameData

  const value = cloneDeep(gamerCondition)

  value[extra.team === 1 ? 'home' : 'away'] = {
    eventCode: EventCode,
    title: currentSportEvents[EventCode].title
  }

  this.setIngameProperty({
    property: 'gamerCondition',
    value
  })
}

export default {
  // 'this' - $store
  byActionType: {},
  // 'this' - $store
  byEventType: {
    'GAMER_CONDITION_HEADACHE' (event) {
      setGamerCondition.call(this, event)
    },
    'GAMER_CONDITION_HIGH_TEMPERATURE' (event) {
      setGamerCondition.call(this, event)
    },
    'GAMER_CONDITION_INTOXICATION' (event) {
      setGamerCondition.call(this, event)
    },
    'GAMER_CONDITION_NORMAL' (event) {
      setGamerCondition.call(this, event)
    },
    'GAMER_CONDITION_TILT' (event) {
      setGamerCondition.call(this, event)
    },
    'MATCH_FORMAT' (event) {
      const { isShootoutSeriesFormat } = this
      const { extra } = event
      const {
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat: firstVersionTimerFormats,
        has_golden_set,
        inverse,
        has_timer,
        timer_speed_up: timerSpeedUp,
        is_shootout_series_format
      } = extra
      const timerFormat = !firstVersionTimerFormats
        ? {
          inverse,
          resetEachPeriod: true
        }
        : firstVersionTimerFormats

      if (isShootoutSeriesFormat) return

      this.setMatchFormat({
        kits,
        matchFormat,
        overtimeFormat,
        timerFormat,
        timerSpeedUp,
        has_golden_set
      })

      this.setIngameProperty({
        property: 'hasTimer',
        value: has_timer
      })

      if (!is_shootout_series_format) return

      this.setShootoutSeriesFormat()
    },
    'PENALTY_FINISH' (event) {
      this.editPeriodScore(event)
    },
    'START_PERIOD' ({ GamePeriod }) {
      const { getIngameData } = this
      const { isReversedField } = getIngameData

      if (GamePeriod === 1) return

      this.setIngameProperty({
        property: 'isReversedField',
        value: !isReversedField
      })
    },
    'LEFT_SIDE_TEAM' ({ TeamNumber }) {
      if (TeamNumber === 2) {
        this.setIngameProperty({
          property: 'isReversedField',
          value: true
        })
      }
    },
    'RED_CARD' ({ extra: { team1, team2 } }) {
      this.setIngameProperty({
        property: 'playersCount',
        value: {
          home: team1,
          away: team2
        }
      })
    },
    'SECOND_YELLOW_CARD' ({ extra: { team1, team2 } }) {
      this.setIngameProperty({
        property: 'playersCount',
        value: {
          home: team1,
          away: team2
        }
      })
    },
    'GOAL' (event) {
      const { GamePeriod, TeamNumber } = event
      const { getMatchPeriods } = this
      const { overriddenType } = getMatchPeriods[GamePeriod]
      const isShootoutPeriod = overriddenType === 'shootout'

      if (isShootoutPeriod) {
        this.updateShootoutStatistic({
          team: getTeamLabelByNumber(TeamNumber),
          value: true
        })
      } else {
        this.setScore(event)
      }
    },
    'SHOOTOUT_MISS' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: false
      })
    },
    'MISS' (event) {
      const { TeamNumber } = event

      this.updateShootoutStatistic({
        team: getTeamLabelByNumber(TeamNumber),
        value: false
      })
    },
    'CANCEL' (event) {
      const { RelatedEventNumber } = event
      const { getEventCache, getCurrentPeriod, getMatchPeriods } = this
      const relatedEvent = getEventCache[RelatedEventNumber]
      const { EventCode, TeamNumber } = relatedEvent
      const { overriddenType } = getMatchPeriods[getCurrentPeriod]
      const isShootoutPeriod = overriddenType === 'shootout'

      if (['GOAL', 'SHOOTOUT_MISS', 'MISS'].includes(EventCode) && isShootoutPeriod) {
        this.updateShootoutStatistic({
          team: getTeamLabelByNumber(TeamNumber),
          type: 'delete'
        })
      }

      if (EventCode === 'START_SHOOTOUT') {
        this.deletePenaltyShootoutFlag(getCurrentPeriod)
        this.clearShootoutFlag()
        this.setEventLogPeriod(getCurrentPeriod)
        this.setStatisticPeriod(getCurrentPeriod)
      }

      if (EventCode === 'RED_CARD' || EventCode === 'SECOND_YELLOW_CARD') {
        const { extra } = event

        if (!extra) return

        const { team1, team2 } = extra

        this.setIngameProperty({
          property: 'playersCount',
          value: {
            home: team1,
            away: team2
          }
        })
      }

      this.setScore(event)
      this.setCanceled(event)
    }
  },
  // 'this' - tradermode component instance
  // для кастомной логики отображения event
  eventTitles: {
    /**
     * @return {string}
     */
    'ADJUST_POINTS' () {
      return this.$t('trader.adjust.score.football')
    },
    /**
     * @return {string}
     */
    'FINISH_GAME' (event) {
      const { GamePeriod, TeamNumber } = event
      const { getMatchPeriods, homeTeamTitle, awayTeamTitle } = this
      const { type, overriddenType } = getMatchPeriods[GamePeriod]

      if (!TeamNumber) {
        return `${this.$t('trader.gameover')} / ${this.$t('trader.draw.capitalized')}`
      }

      const teamTitle = TeamNumber === 1 ? homeTeamTitle : awayTeamTitle

      if (overriddenType === 'shootout') {
        return `${this.$t('trader.gameover')} / ${teamTitle} ${this.$t('trader.win.penaltyshootout')}`
      }

      if (type === 'overtime') {
        return `${this.$t('trader.gameover')} / ${teamTitle} ${this.$t('trader.win.overtime.football')}`
      }

      return `${this.$t('trader.gameover')} / ${teamTitle} ${this.$t('trader.win.maintime')}`
    }
  },
  eventClasses: {
    /**
     * @return {string}
     */
    'ADDITIONAL_TIME' ({ extra: { minutes } }) {
      if (!minutes) return ''

      return '_green'
    }
  },
  customVictoryTitle (event) {
    const { GamePeriod } = event
    const { getMatchPeriods, getWinner } = this

    if (getWinner === 'draft') return

    const { type, overriddenType } = getMatchPeriods[GamePeriod]

    if (overriddenType === 'shootout') return this.$t('trader.win.penaltyshootout')

    if (type === 'overtime') return this.$t('trader.win.overtime.football')

    return this.$t('trader.win.maintime')
  }
}
